import * as transformers from '../values/transformers';
import getPanel from './element/get_panel';
import getForm from './element/get_form';
import getLeadform from './element/get_leadform';

export { getPanel, getForm, getLeadform };

// Processes a field
export function processField(field) {
  const rawValue = exports.fieldValue(field);
  return transformers.transformFieldValue(rawValue, field.name);
}

// Extracts a value from a given field
export function fieldValue(field) {
  if (field == null) {
    return null;
  } else if (field.tagName === 'SELECT') {
    return exports.selectFieldValue(field);
  } else if (['checkbox', 'radio'].indexOf(field.type) > -1) {
    return exports.checkFieldValue(field);
  } else {
    return field.value;
  }
}

// Extracts a value from a checkbox field
export function checkFieldValue(field) {
  return field.checked ? field.value : undefined;
}

// Extracts a value from a select field
export function selectFieldValue(field) {
  const option = field.options[field.selectedIndex];
  return option ? option.value : undefined;
}

// Returns true if something has been entered into a field
export function isEntered(field) {
  const value = exports.fieldValue(field);
  return (value != null && value !== '');
}

// Returns if the field is active in the leadform:
// Note: Vashon has a definition of active
export function isActive(field) {
  return true;
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/field.js